import React from 'react';
import ReactMarkdown from 'react-markdown';
import postContent from './posts/inverse-constraint-rl-content';

export default function InverseConstraintRL() {
  return (
    <main className="content">
      <div className="blog-post">
        <ReactMarkdown>{postContent}</ReactMarkdown>
      </div>
    </main>
  );
}
